var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatured({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_15923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.175 30.375H19.0649C18.5349 30.375 18.2698 30.375 18.1471 30.2702C18.0406 30.1792 17.9841 30.0428 17.9951 29.9032C18.0077 29.7423 18.1951 29.5549 18.57 29.18L26.0101 21.7399C26.3566 21.3934 26.5298 21.2202 26.7296 21.1553C26.9053 21.0982 27.0947 21.0982 27.2704 21.1553C27.4702 21.2202 27.6434 21.3934 27.9899 21.7399L31.375 25.125V26.175M27.175 30.375C28.6451 30.375 29.3802 30.375 29.9417 30.0889C30.4357 29.8372 30.8372 29.4357 31.0889 28.9417C31.375 28.3802 31.375 27.6451 31.375 26.175M27.175 30.375H19.825C18.3549 30.375 17.6198 30.375 17.0583 30.0889C16.5643 29.8372 16.1628 29.4356 15.9111 28.9417C15.625 28.3802 15.625 27.6451 15.625 26.175V18.825C15.625 17.3549 15.625 16.6198 15.9111 16.0583C16.1628 15.5643 16.5643 15.1628 17.0583 14.9111C17.6198 14.625 18.3549 14.625 19.825 14.625H27.175C28.6451 14.625 29.3802 14.625 29.9417 14.9111C30.4356 15.1628 30.8372 15.5643 31.0889 16.0583C31.375 16.6198 31.375 17.3549 31.375 18.825V26.175M22.1875 19.4375C22.1875 20.404 21.404 21.1875 20.4375 21.1875C19.471 21.1875 18.6875 20.404 18.6875 19.4375C18.6875 18.471 19.471 17.6875 20.4375 17.6875C21.404 17.6875 22.1875 18.471 22.1875 19.4375Z",
    stroke: "#475467",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_15923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13.5 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatured);
export default __webpack_public_path__ + "static/media/featured.4b0542979d463781bb6845118aae9ae0.svg";
export { ForwardRef as ReactComponent };